import * as Sentry from '@sentry/nuxt'

// @ts-expect-error global state
const { sentryDsn, environment, brand } = useRuntimeConfig().public

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment,
    debug: false,
    enableLogs: false,
    sendDefaultPii: false,
    sampleRate: 0.4,
    tracesSampleRate: 0,
    initialScope: {
      tags: {
        brand,
      },
    },
    ignoreErrors: [
      /RTCDataChannel\.readyState is not 'open'/,
    ],
  })
}
